function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 408.8 408.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M166.7 116.4 290 292.8h-22.6L144.1 116.4h22.6zm242.1-61.3v298.6c0 30.4-24.7 55.1-55.1 55.1H55.1C24.7 408.8 0 384.1 0 353.7V55.1C0 24.7 24.7 0 55.1 0h298.6c30.4 0 55.1 24.7 55.1 55.1zM322.1 310l-82.8-121.5 76.6-89.7h-22.8l-64.7 74.3-51.1-74.3h-61.5v4h1.4l77.6 113.1-1.5-1.3-81.6 95.4h22.8l68.1-79.1 53.9 78.2.6.9H322z",
    fill: "currentColor",
    style: {
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter-icon.2a2323deaa10271441ace557db1287ef.svg";
export { ForwardRef as ReactComponent };